<template>
  <header class="header">
    <div
      class="container d-flex align-items-center"
      style="justify-content: space-between"
    >
      <router-link class="logo" :to="currentStep.defaultPath">
        <img
          style="width: 100px; height: auto"
          src="../../assets/imgs/beta.svg"
        />
      </router-link>

      <div
        style="
          color: #fff;
          width: calc(100% - 30px);
          padding: 0 15px;
          font-size: 20px;
          text-align: center;
          overflow: hidden;
          text-overflow: ellipsis;
        "
      >
        <div class="main__title">ASAN MÜRACİƏT İNFORMASİYA SİSTEMİ</div>
        <p>{{amis}}</p>
      </div>

      <a-dropdown
        :trigger="['click']"
        v-if="currentStep.hasNotification"
        style="margin-left: auto"
        @visibleChange="handleNotifVisibleChange"
      >
        <a-badge
          :count="notificationCount"
          :showZero="false"
          style="margin-right: 20px"
        >
          <a class="ant-dropdown-link" href="#">
            <a-icon type="bell" style="font-size: 25px; color: white" />
          </a>
        </a-badge>

        <notification-panel
          slot="overlay"
          :visible="notificationVisibility"
          @change="handleNotificationChange"
        >
        </notification-panel>
      </a-dropdown>

      <a-dropdown
        :trigger="['click']"
        :style="currentStep.hasNotification ? '' : 'marginLeft:auto;'"
        style="text-align: center"
      >
        <a
          class="ant-dropdown-link account-button"
          style="
            font-weight: 100;
            font-size: 14px;
            display: flex;
            flex-direction: column;
            align-items: center;
            min-width: fit-content;
            width: 160px;
          "
        >
          <span>{{ user.firstName }} {{ user.lastName }}</span>

          <span>{{ usergroup() }}</span>

          <a-icon
            style="font-size: 20px; position: relative; top: 0"
            type="down"
          />
        </a>

        <a-menu slot="overlay">
          <a-menu-item
            @click="setUserGroupType(item.id)"
            v-for="item in userGroupTypes"
            :key="item.id"
            :disabled="item.id == userGroupType"
          >
            <a>{{ item.name }}</a>
          </a-menu-item>
          <a-menu-item v-if="steps() != null">
            <a target="_blank" :href="steps()">Təlimat</a>
          </a-menu-item>
          <a-menu-divider />
          <!--  <a-menu-item @click="goToAdmin"> Tənzimləmələr </a-menu-item> -->
          <a-menu-item @click="logout">Çıxış</a-menu-item>
        </a-menu>
      </a-dropdown>

      <div @click="goToAdmin" style="cursor: pointer; margin-left: 20px">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          enable-background="new 0 0 24 24"
          height="25px"
          viewBox="0 0 24 24"
          width="25px"
          fill="#FFFFFF"
        >
          <g>
            <rect fill="none" height="24" width="24" />
            <path
              d="M21.69,16.37l1.14-1l-1-1.73l-1.45,0.49c-0.32-0.27-0.68-0.48-1.08-0.63L19,12h-2l-0.3,1.49c-0.4,0.15-0.76,0.36-1.08,0.63 l-1.45-0.49l-1,1.73l1.14,1c-0.08,0.5-0.08,0.76,0,1.26l-1.14,1l1,1.73l1.45-0.49c0.32,0.27,0.68,0.48,1.08,0.63L17,22h2l0.3-1.49 c0.4-0.15,0.76-0.36,1.08-0.63l1.45,0.49l1-1.73l-1.14-1C21.77,17.13,21.77,16.87,21.69,16.37z M18,19c-1.1,0-2-0.9-2-2s0.9-2,2-2 s2,0.9,2,2S19.1,19,18,19z M19,4v6h-2V6h-2v6h-2V5H7v14h5v2H3v-2h2V3h10v1H19z M12,13h-2v-2h2V13z"
            />
          </g>
        </svg>
      </div>
    </div>

  </header>
</template>

<script>
import { mapGetters } from "vuex";
import GLOBALS from "../../global/store";
import mixin from "@/mixins/index";
import { URL, apiCall } from "@/utils/api";
import NotificationPanel from "@/components/partials/NotificationPanel/index";


export default {
  name: "AppHeader",
  mixins: [mixin],
  computed: {
    ...mapGetters({
      user: "user/user",
      userGroupTypes: "user/userGroupTypes",
      userGroupType: "user/userGroupType",
      amis:'user/amis'
    }),
  },
  components: {
    "notification-panel": NotificationPanel,
  },
  data() {
    return {
      notificationCount: 0,
      notificationVisibility: false,
    };
  },
  methods: {


    logout() {
      this.$store
        .dispatch("user/logout")
        .then(() => {
          console.log(URL[process.env.NODE_ENV].auth_origin);
          return (window.location.href = `${
            URL[process.env.NODE_ENV].auth_origin
          }?logout=true`);
        })
        .catch(() => {
          return (window.location.href = `${
            URL[process.env.NODE_ENV].auth_origin
          }?logout=true`);
        });
    },
    setUserGroupType(id) {
      let userGroup = this.userGroupTypes.find((item) => item.id === id);
      this.$store
        .dispatch("user/setUserGroupType", id)
        .then(() => {
          return (window.location.href = userGroup.defaultPath);
        })
        .catch((error) => {
          console.log(error);
        });
    },
    steps() {
      let steps = this.userGroupTypes.find(
        (item) => item.id == this.userGroupType
      );

      return (
        steps.documentationFile &&
        URL[process.env.NODE_ENV].file_url + "/" + steps.documentationFile
      );
    },
    usergroup() {
      let userGroup = this.userGroupTypes.find(
        (item) => item.id == this.userGroupType
      );
      return userGroup ? userGroup.name : null;
    },
    handleNotifVisibleChange(vis) {
      this.notificationVisibility = vis;
    },
    goToAdmin() {
      window.location.assign(URL[process.env.NODE_ENV].auth_exec_page_origin);
    },
    getNotificationsCount() {
      if (this.currentStep.hasNotification) {
        apiCall({
          url: URL[process.env.NODE_ENV].service_api + "notifications/count",
          method: "GET",
        })
          .then((response) => {
            if (!response.data.error) {
              this.notificationCount = response.data.data;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    handleNotificationChange() {
      this.getNotificationsCount();
    },
  },
  async created() {
 
    if (localStorage.getItem("menuT")) {
      GLOBALS.SELMENU = [localStorage.getItem("menuT")];
    } else GLOBALS.SELMENU = ["new"];
  },
  mounted() {
    document.title = this.user.firstName + " " + this.user.lastName;
    this.getNotificationsCount();
    setInterval(() => {
      this.getNotificationsCount();
    }, 300000);
  },
};
</script>

<style scoped lang="scss">
.header {
  align-items: center;
  background-image: var(--headerBackgroundImage);
  display: flex;
  justify-content: center;
  height: 4.5rem;
  padding: {
    left: 1rem;
    right: 1rem;
  }
  width: 100%;
  min-height: 90px;

  .logo {
    padding: 0.5rem;
    img {
      height: 2.25rem;
    }
  }

  .title {
    color: #fff;
    font-size: 1rem;
    font-weight: 500;
    margin: {
      bottom: 0;
      top: 0;
    }
  }

  .account-button {
    background-color: transparent;
    text-decoration-line: none;
    border: none;
    color: #fff;
    cursor: pointer;
    margin: {
      left: 1rem;
    }
  }
}

.ant-dropdown-menu-item-disabled {
  cursor: not-allowed;
  li {
    a {
      cursor: not-allowed;
    }
  }
}

.page {
  background: #fff;
  padding: 1rem;
  border: 1px solid #e8e8e8;
  border-radius: 0.3rem;
}

.ml-1 {
  margin: {
    left: 1rem;
  }
}

.mr-1 {
  margin: {
    right: 1rem;
  }
}

.container {
  max-width: 90rem;
  width: 100%;
}

.d-flex {
  display: flex;
}

.align-items-center {
  align-items: center;
}

.justify-content-center {
  justify-content: center;
}

.mlf-auto {
  margin: {
    left: auto;
    right: auto;
  }
}

@media only screen and (max-width: 600px) {
  .main__title,
  .sub__title {
    font-size: 9px;
  }

  .logo {
    padding: 0px !important;

    img {
      width: 60px !important;
    }
  }
  .header {
    .container {
      transform: translate(-10px, -10px);
      .ant-dropdown-trigger {
        font-size: 11px !important;
      }
    }
  }
}
</style>
